import { IconProps } from '../types';

const IcPlayV2 = (props: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    {...props}
  >
    <path
      d='M12.333 22.6002L22.5997 16.0002L12.333 9.40016V22.6002ZM15.9997 30.6668C13.9708 30.6668 12.0641 30.2818 10.2797 29.5118C8.49523 28.7418 6.94301 27.6968 5.62301 26.3768C4.30301 25.0568 3.25801 23.5046 2.48801 21.7202C1.71801 19.9357 1.33301 18.0291 1.33301 16.0002C1.33301 13.9713 1.71801 12.0646 2.48801 10.2802C3.25801 8.49572 4.30301 6.9435 5.62301 5.6235C6.94301 4.3035 8.49523 3.2585 10.2797 2.4885C12.0641 1.7185 13.9708 1.3335 15.9997 1.3335C18.0286 1.3335 19.9352 1.7185 21.7197 2.4885C23.5041 3.2585 25.0563 4.3035 26.3763 5.6235C27.6963 6.9435 28.7413 8.49572 29.5113 10.2802C30.2813 12.0646 30.6663 13.9713 30.6663 16.0002C30.6663 18.0291 30.2813 19.9357 29.5113 21.7202C28.7413 23.5046 27.6963 25.0568 26.3763 26.3768C25.0563 27.6968 23.5041 28.7418 21.7197 29.5118C19.9352 30.2818 18.0286 30.6668 15.9997 30.6668ZM15.9997 27.7335C19.2752 27.7335 22.0497 26.5968 24.323 24.3235C26.5963 22.0502 27.733 19.2757 27.733 16.0002C27.733 12.7246 26.5963 9.95016 24.323 7.67683C22.0497 5.4035 19.2752 4.26683 15.9997 4.26683C12.7241 4.26683 9.94967 5.4035 7.67634 7.67683C5.40301 9.95016 4.26634 12.7246 4.26634 16.0002C4.26634 19.2757 5.40301 22.0502 7.67634 24.3235C9.94967 26.5968 12.7241 27.7335 15.9997 27.7335Z'
      fill='white'
    />
  </svg>
);

export default IcPlayV2;
